import { useState } from "react";
import type { InputHTMLAttributes } from "react";
import { AuthField } from "./AuthField";

type AuthPasswordFieldProps = {
  label: string;
  error?: string | null;
} & Omit<InputHTMLAttributes<HTMLInputElement>, "type">;

export function AuthPasswordField({
  label,
  error,
  ...props
}: AuthPasswordFieldProps) {
  const [visible, setVisible] = useState(false);

  return (
    <div className="auth-password-field" data-oid="q23ox4n">
      <AuthField
        {...props}
        label={label}
        type={visible ? "text" : "password"}
        error={error}
        leadingIcon={
          label.toLowerCase().includes("confirm") ? "verified" : "lock"
        }
        data-oid="rz3ty3."
      />

      <button
        type="button"
        className="auth-password-field__toggle"
        aria-label={
          visible ? "Hide password characters" : "Show password characters"
        }
        onClick={() => setVisible((current) => !current)}
        data-oid="ln16p_p"
      >
        <span className="material-symbols-outlined" data-oid=".u:en3g">
          {visible ? "visibility_off" : "visibility"}
        </span>
      </button>
    </div>
  );
}
